/**
 * 관리자 홈 Container
 * --
 */
import React from 'react';
// import MainHomePresenter from './MainHomePresenter';
import OrderDashboardContainer from 'routes/admin.routes/admin.dashboard/OrderDashboard';
import { useUserStack } from 'store';

const OrderDashboard = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <OrderDashboardContainer
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
          shopType={'SHOP'}
        />
      )}
    </>
  );
};

export default OrderDashboard;
